import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

class BookingReservationCountdown extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      countdown: ''
    }
    this.renewReservation = props.renewReservation.bind(this)
    this.calculateCountdown = this.calculateCountdown.bind(this)
  }

  componentDidMount() {
    this.countdownInterval = setInterval(this.calculateCountdown, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval)
  }
  
  calculateCountdown() {
    const { reservation } = this.props
    if (!reservation) {
      return
    }

    const minutesToComplete = 10
    const endDate = new Date(reservation.updatedAt).getTime() + minutesToComplete * 60000
    let startDate = new Date();
    startDate = startDate.getTime();
    let timeRemaining = parseInt(endDate - startDate, 10) / 1000;
    if (timeRemaining >= 0) {
      const minutes = parseInt((timeRemaining / 60), 10);
      timeRemaining %= 60;
      const seconds = parseInt(timeRemaining, 10);
      this.setState({ countdown: `${(minutes < 10 ? `0${minutes}` : minutes)}:${(seconds < 10 ? `0${seconds}` : seconds)}` })
    }
  }

  render() {
    const { state } = this
    return (
      <div className="bg-grass p-4 pb-1 my-4 text-sm">
        <p>
          <FormattedMessage
            id="booking.people.reservationLn1"
            defaultMessage="Your time slot reservation will expire in {countdown} minutes."
            values={{ countdown: <b>{state.countdown}</b> }}
          />
          <br />
          <button
            type="button"
            className="font-bold text-harbor"
            onClick={() => { this.renewReservation() }}
          >
            <FormattedMessage id="booking.people.reservationLn2Link" defaultMessage="Click here" />
          </button>
          &nbsp;
          <FormattedMessage id="booking.people.reservationLn2" defaultMessage="to extend your reservation, so you don't loose your spot." />
        </p>
      </div>
    )
  }
}

BookingReservationCountdown.propTypes = {
  reservation: PropTypes.shape({ reservation: PropTypes.object }).isRequired,
  renewReservation: PropTypes.func.isRequired
}

export default BookingReservationCountdown

